/* eslint-disable  react/display-name*/
import {
  Button,
  CircularProgress,
  IconButton,
  Tooltip,
  Typography,
  Grid,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import HomeIcon from "@mui/icons-material/Home";
import RefreshIcon from "@mui/icons-material/Refresh";
import SaveIcon from "@mui/icons-material/Save";

import MUIDataTable from "mui-datatables";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import API from "../../../utils/API";
import { StringUtils } from "../../../utils/StringUtils";
import GenericReportViewer from "./../../reports/GenericReportViewer";
import PurchaseRequestDraftWindow from "./purchase-reqest-draft/PurchaseRequestDraftWindow";
import QuickPurchaseRequestWindow from "./quick-purchase-request/QuickPurchaseRequestWindow";
import PConfirm from "../../../components/pos/PConfirm";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}
export default function PurchaseOrderList(props) {
  const { t } = useTranslation();
  const translate = t;
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [rowLimitPerPage, setRowLimitPerPage] = useState(
    Math.round((getWindowDimensions().height - 162) / 33)
  );
  const [confirmContext, setConfirmContext] = useState({ open: false });
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [selectedRowStatus, setSelectedRowStatus] = useState("");

  useEffect(() => {
    loadData("DRAFT");
  }, []);

  function handleQuickPurchaseRequestClick() {
    biRef.quickEntry.showQuickPurchaseRequestWindow(null, "create", false);
  }

  function handlePurchaseRequestClick() {
    biRef.draftEntry.showPurchaseRequestDraftWindow(null, "create", false);
  }

  function onPrintClicked(row) {
    if (row.rowData[4] == "GRN" && row.rowData[5] == "SETTLED") {
      let paramsList = [
        {
          key: "purchaseOrderId",
          value: row.tableData[row.rowIndex].id,
        },
      ];

      biRef.genericReportView.showGenericReportViewer(
        "reports/generic/goods_receive_note",
        paramsList,
        "Purchase Settlement "
      );
    }
    if (row.rowData[4] == "LPO") {
      let paramsList = [
        {
          key: "purchaseOrderId",
          value: row.tableData[row.rowIndex].id,
        },
      ];

      biRef.genericReportView.showGenericReportViewer(
        "reports/generic/local_purchase_order",
        paramsList,
        "Purchase Request "
      );
    }
  }

  async function onYesNoClicked(context, value) {
    setConfirmOpen(false);
    if (value == "yes") {
      onEditClicked(
        context.row,
        context.updateValue,
        context.value,
        context.type
      );
    }
  }

  function onEditSettledPo(row, updateValue, value, type) {
    setSelectedRowStatus(row.tableData[row.rowIndex].status);
    setConfirmOpen(true);
    setConfirmContext({
      title: "Are You Sure",
      message: translate(
        "Are you sure to edit purchase order, your stock and cost calculation may not be correct after the purchase eidt, Please run stock reconcilation for fixing the cost and stock"
      ),
      type: "warning",
      open: true,
      yes: true,
      no: true,
      row: row,
      updateValue: updateValue,
      value: value,
      type: type,
    });
    //onEditClicked(row, updateValue, value, type);
  }
  function onEditClicked(row, updateValue, value, type) {
    setSelectedRowStatus(row.tableData[row.rowIndex].status);
    console.log("testing", row.tableData[row.rowIndex].status);
    if (row.tableData[row.rowIndex].isQuickEntry || type === "Settle") {
      biRef.quickEntry.showQuickPurchaseRequestWindow(
        row.tableData[row.rowIndex].id,
        type,
        false
      );
    } else {
      biRef.draftEntry.showPurchaseRequestDraftWindow(
        row.tableData[row.rowIndex].id,
        type,
        false
      );
    }
  }

  async function loadData(status) {
    let sort = '[{id:"orderId",sortOrder:"DESC"}]';
    let search = "[]";
    if (status) {
      let str = "[";
      str +=
        '{id:"status",value:"' +
        status +
        '",regExp:"",matchType:"EXACT_MATCH",operatorType:"",fieldValueType:"string"}';
      str +=
        ',{id:"returnFlag",value:"false",regExp:"",matchType:"EXACT_MATCH",operatorType:"",fieldValueType:"boolean"}';
      str += "]";
      search = str;
    }
    loadByRest(0, rowLimitPerPage, sort, search);
    //loaadByDB();
  }
  async function loadByRest(curPage, pageSize, sort, filter) {
    setIsLoading(true);
    const result = await API.get(
      "/api/v1/purchaseorder/list?range=" +
        encodeURIComponent(
          "[" + curPage * pageSize + "," + ((curPage + 1) * pageSize - 1) + "]"
        ) +
        "&filter=" +
        encodeURIComponent(filter) +
        "&sort=" +
        encodeURIComponent(sort)
    );

    var arr = result.headers["content-range"].split("/");

    const opt = { ...option };
    opt.count = parseInt(arr[2]);
    setOption(opt);
    setData(result.data.data);
    setIsLoading(false);
  }

  async function onTableChange(tableState) {
    let sort = '[{id:"date",sortOrder:"DESC"}]';
    /*if (tableState.sortOrder.name) {
      sort =
        '[{id:"' +
        tableState.sortOrder.name +
        '",desc:' +
        (tableState.sortOrder.direction === "desc" ? "true}]" : "false}]");
    }
    if (tableState.sortOrder.name) {
      sort =
        '[{id:"' +
        tableState.sortOrder.name +
        '",desc:' +
        (tableState.sortOrder.direction === "desc" ? "true}]" : "false}]");
    }*/

    let search = "[";
    search +=
      '{id:"status",value:"' +
      (tableState.filterList[5][0] ? tableState.filterList[5][0] : "DRAFT") +
      '",regExp:"",matchType:"EXACT_MATCH",operatorType:"",fieldValueType:"string"}';
    search +=
      ',{id:"returnFlag",value:"false",regExp:"",matchType:"EXACT_MATCH",operatorType:"",fieldValueType:"boolean"}';
    if (tableState.searchText) {
      search +=
        ',{id:"invoiceNumber",value:"",regExp:"' +
        tableState.searchText +
        '",matchType:"BROAD_MATCH",operatorType:"",fieldValueType:"string","conditionType":"or"}';
      search +=
        ',{id:"orderId",value:"",regExp:"' +
        tableState.searchText +
        '",matchType:"BROAD_MATCH",operatorType:"",fieldValueType:"string","conditionType":"or"}';
      search +=
        ',{id:"displayVendorName",value:"",regExp:"' +
        tableState.searchText +
        '",matchType:"BROAD_MATCH",operatorType:"",fieldValueType:"string","conditionType":"or"}';
      search +=
        ',{id:"actualAmountToPay",value:"",regExp:"' +
        tableState.searchText +
        '",matchType:"BROAD_MATCH",operatorType:"",fieldValueType:"string","conditionType":"or"}';
    }
    search += "]";
    loadByRest(tableState.page, rowLimitPerPage, sort, search);
  }

  const options = {
    download: false,
    searchPlaceholder: "Search by Invoice Number",
    serverSide: true,
    searchable: true,
    viewColumns: false,
    filter: true,
    filterType: "dropdown",
    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,
    tableBodyMaxHeight: "100%",
    tableBodyHeight: getWindowDimensions().height - 162,
    rowsPerPage: Math.round((getWindowDimensions().height - 162) / 33),
    rowsPerPageOptions: [
      Math.round((getWindowDimensions().height - 162) / 33),
      10,
      15,
      50,
      100,
    ],
    print: false,
    onTableChange: (action, tableState) => {
      // a developer could react to change on an action basis or
      // examine the state as a whole and do whatever they want
      switch (action) {
        case "changePage":
          onTableChange(tableState);
          break;
        case "sort":
          onTableChange(tableState);
          break;
        case "changeRowsPerPage":
          onTableChange(tableState);
          break;
        case "search":
          onTableChange(tableState);
          break;
        case "filterChange":
          onTableChange(tableState);
          break;
        default:
        //console.log("action not handled." + action);
      }
    },
    customToolbar: () => {
      return (
        <React.Fragment>
          <Tooltip title={"Refresh Data"}>
            <IconButton
              size="small"
              color="primary"
              onClick={purchaseorderListRefresh}
            >
              <RefreshIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="GRN">
            <IconButton
              size="small"
              color="primary"
              onClick={handleQuickPurchaseRequestClick}
            >
              <AddIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title={"LPO"}>
            <IconButton
              size="small"
              color="primary"
              onClick={handlePurchaseRequestClick}
            >
              <SaveIcon />
            </IconButton>
          </Tooltip>
        </React.Fragment>
      );
    },
  };

  const [option, setOption] = useState(options);
  const columns = [
    {
      name: "orderId",
      label: translate("Order Id"),
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "date",
      label: translate("Date"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        setCellHeaderProps: () => ({
          align: "left",
          "@media only screen and (max-width: 600px)": {},
        }),
        setCellProps: () => ({ align: "left" }),
        customBodyRender: (value, tableMeta, updateValue) => {
          return StringUtils.formatDate(new Date(value), 1);
        },
      },
    },
    {
      name: "invoiceNumber",
      label: translate("Invoice Number"),
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "displayVendorName",
      label: translate("Vendor"),
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "orderType",
      label: translate("Order Type"),
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "status",
      label: translate("Status"),
      options: {
        filter: true,
        sort: false,
        filterOptions: {
          names: ["DRAFT", "SETTLED", "REQUESTED"],
        },
      },
    },
    {
      name: "amount",
      label: translate("Final Amount"),
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return StringUtils.formattedNumber(
            value,
            props.context.store.currencyDecimal
          );
        },
      },
    },
    {
      name: "action",
      label: translate("Actions"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        setCellHeaderProps: () => ({ align: "center" }),
        setCellProps: () => ({ align: "center" }),
        customBodyRender: (value, tableMeta, updateValue) => (
          <div>
            {tableMeta.tableData[tableMeta.rowIndex].status == "REQUESTED" && (
              <table align="center">
                <tr>
                  <td>
                    <Button
                      onClick={() =>
                        onEditClicked(
                          tableMeta,
                          updateValue,
                          value,

                          (tableMeta.tableData[tableMeta.rowIndex].orderType ===
                            "LPO" &&
                            props.context.privileges.lpo_lro_requested_edit) ||
                            (tableMeta.tableData[tableMeta.rowIndex]
                              .orderType === "GRN" &&
                              props.context.privileges.grn_grv_requested_edit)
                            ? "Settle"
                            : "View"
                        )
                      }
                      color="secondary"
                      style={{
                        margin: 0,
                        padding: 0,
                        height: 17,
                        width: 27,
                        alignText: "right",
                      }}
                    >
                      {(tableMeta.tableData[tableMeta.rowIndex].orderType ===
                        "LPO" &&
                        props.context.privileges.lpo_lro_requested_edit) ||
                      (tableMeta.tableData[tableMeta.rowIndex].orderType ===
                        "GRN" &&
                        props.context.privileges.grn_grv_requested_edit)
                        ? translate("Settle")
                        : translate("View")}
                    </Button>
                  </td>
                  <td>
                    <Button
                      onClick={() => onPrintClicked(tableMeta)}
                      color="secondary"
                      style={{
                        margin: 0,
                        padding: 0,
                        height: 17,
                        width: 27,
                        alignText: "right",
                      }}
                    >
                      {translate("Print")}
                    </Button>
                  </td>
                </tr>
              </table>
            )}
            {tableMeta.tableData[tableMeta.rowIndex].status == "SETTLED" && (
              <div>
                <table align="center">
                  <tr>
                    <td>
                      <Button
                        onClick={() =>
                          onEditClicked(tableMeta, updateValue, value, "View")
                        }
                        color="secondary"
                        style={{
                          margin: 0,
                          padding: 0,
                          height: 17,
                          width: 27,
                          alignText: "right",
                        }}
                      >
                        {translate("View")}
                      </Button>
                    </td>

                    {(props.context.storeAdmin.allowEditingPo ||
                      (tableMeta.tableData[tableMeta.rowIndex].orderType ===
                        "LPO" &&
                        props.context.privileges.lpo_lro_settled_edit) ||
                      (tableMeta.tableData[tableMeta.rowIndex].orderType ===
                        "GRN" &&
                        props.context.privileges.grn_grv_settled_edit)) && (
                      <td>
                        <Button
                          onClick={() =>
                            onEditSettledPo(
                              tableMeta,
                              updateValue,
                              value,
                              "Settle"
                            )
                          }
                          color="secondary"
                          style={{
                            margin: 0,
                            padding: 0,
                            height: 17,
                            width: 27,
                            alignText: "right",
                          }}
                        >
                          {translate("Edit")}
                        </Button>
                      </td>
                    )}

                    <td>
                      <Button
                        onClick={() => onPrintClicked(tableMeta)}
                        color="secondary"
                        style={{
                          margin: 0,
                          padding: 0,
                          height: 17,
                          width: 27,
                          alignText: "right",
                        }}
                      >
                        {translate("Print")}
                      </Button>
                    </td>
                  </tr>
                </table>
              </div>
            )}
            {tableMeta.tableData[tableMeta.rowIndex].status == "DRAFT" && (
              <Button
                onClick={() =>
                  onEditClicked(
                    tableMeta,
                    updateValue,
                    value,

                    (tableMeta.tableData[tableMeta.rowIndex].orderType ===
                      "LPO" &&
                      (props.context.privileges.lpo_lro_draft_edit ||
                        props.context.privileges.lpo_lro_delete)) ||
                      (tableMeta.tableData[tableMeta.rowIndex].orderType ===
                        "GRN" &&
                        (props.context.privileges.grn_grv_draft_edit ||
                          props.context.privileges.grn_grv_delete))
                      ? "Edit"
                      : "View"
                  )
                }
                color="secondary"
                style={{
                  margin: 0,
                  padding: 0,
                  height: 17,
                  width: 27,
                  alignText: "right",
                }}
              >
                {(tableMeta.tableData[tableMeta.rowIndex].orderType === "LPO" &&
                  props.context.privileges.lpo_lro_draft_edit) ||
                (tableMeta.tableData[tableMeta.rowIndex].orderType === "GRN" &&
                  props.context.privileges.grn_grv_draft_edit)
                  ? translate("Edit")
                  : translate("View")}
              </Button>
            )}
          </div>
        ),
      },
    },
  ];

  function purchaseorderListRefresh() {
    loadData("DRAFT");
  }

  var biRef = {};

  return (
    <Grid container>
      <Grid item xs={12}>
        <div>
          <MUIDataTable
            title={
              <Typography variant="h6">
                {translate("Purchase Request List")}
                {isLoading && (
                  <CircularProgress
                    size={24}
                    style={{ marginLeft: 15, position: "relative", top: 4 }}
                  />
                )}
              </Typography>
            }
            data={data}
            columns={columns}
            options={option}
          />
        </div>
      </Grid>
      <QuickPurchaseRequestWindow
        biRef={biRef}
        showMessage={props.showMessage}
        setAlert={props.setAlert}
        context={props.context}
        onRefresh={purchaseorderListRefresh}
        productCache={props.productCache}
        selectedRowStatus={selectedRowStatus}
      ></QuickPurchaseRequestWindow>
      <PurchaseRequestDraftWindow
        biRef={biRef}
        showMessage={props.showMessage}
        setAlert={props.setAlert}
        context={props.context}
        onRefresh={purchaseorderListRefresh}
        selectedRowStatus={selectedRowStatus}
      ></PurchaseRequestDraftWindow>
      <GenericReportViewer
        biRef={biRef}
        showMessage={props.showMessage}
        setAlert={props.setAlert}
        context={props.context}
      ></GenericReportViewer>
      {confirmOpen && (
        <PConfirm
          open={confirmOpen}
          context={confirmContext}
          onButtonClicked={onYesNoClicked}
        ></PConfirm>
      )}
    </Grid>
  );
}
